export default __webpack_public_path__ + "static/media/3.ee611d89.png";